import { render, staticRenderFns } from "./ExamsTable.vue?vue&type=template&id=4e634d06&scoped=true&"
import script from "./ExamsTable.vue?vue&type=script&lang=js&"
export * from "./ExamsTable.vue?vue&type=script&lang=js&"
import style0 from "./ExamsTable.vue?vue&type=style&index=0&id=4e634d06&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e634d06",
  null
  
)

export default component.exports